import React from "react";
import { Card, Text } from "@nextui-org/react";

const AltLedgerFooter = ({ totals = {} }) => {
  return (
    <Card.Footer
      css={{
        justifyContent: "flex-start",
        py: "16px",
        px: "20px",
      }}
    >
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          gap: "28px",
        }}
      >
        <Text size="15px" css={{ margin: 0 }}>
          <Text span color="$accents7">
            Shop Total:{" "}
          </Text>
          <Text span b color="warning">
            &#8377;
            {Math.ceil(totals.shopTotal || 0).toLocaleString("en-IN")}
          </Text>
        </Text>

        <Text size="15px" css={{ margin: 0 }}>
          <Text span color="$accents7">
            Sunil C:{" "}
          </Text>
          <Text span b color="error">
            &#8377;
            {Math.ceil(totals.sunilC || 0).toLocaleString("en-IN")}
          </Text>
        </Text>

        <Text size="15px" css={{ margin: 0 }}>
          <Text span color="$accents7">
            Customer:{" "}
          </Text>
          <Text span b>
            &#8377;{Math.ceil(totals.customerTotal || 0).toLocaleString("en-IN")}
          </Text>
        </Text>

        <Text size="15px" css={{ margin: 0 }}>
          <Text span color="$accents7">
            Profit:{" "}
          </Text>
          <Text span b color={(totals.profit || 0) >= 0 ? "secondary" : "error"}>
            &#8377;{Math.ceil(totals.profit || 0).toLocaleString("en-IN")}
          </Text>
        </Text>
      </div>
    </Card.Footer>
  );
};

export default AltLedgerFooter;
